import { ChangeDetectorRef, DestroyRef, Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { LocalizedAsset } from '@warema/shared/models';
import { LocalizedAssetUtilities } from '@warema/shared/utilities';

@Injectable({
    providedIn: 'root',
})
@Pipe({
    name: 'translateAsset',
    pure: false,
})
export class TranslateAssetPipe implements PipeTransform {
    private readonly _translateService = inject(TranslateService);
    private readonly _changeDetectorRef = inject(ChangeDetectorRef);
    private readonly _destroyRef = inject(DestroyRef);

    private _currentValue: unknown = undefined;

    public transform<T>(asset: LocalizedAsset<T>): T {
        // update value
        this._updateValue(asset, this._translateService.getCurrentLang());

        // subscribe to onLangChange event, in case the language changes
        this._translateService.onLangChange.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(x => {
            this._updateValue(asset, x.lang);
        });

        // subscribe to onDefaultLangChange event, in case the default language changes
        this._translateService.onFallbackLangChange.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(x => {
            this._updateValue(asset, x.lang);
        });

        return this._currentValue as T;
    }

    private _updateValue<T>(asset: LocalizedAsset<T>, language: string): void {
        this._currentValue = LocalizedAssetUtilities.getLocalizedAsset(asset, language);
        this._changeDetectorRef.markForCheck();
    }
}
